export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--5.aab73052.png";